import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../utilities/classNames';
import evaluate from '../../utilities/props';

const Button = ({ active = false, children, className, ...props }) => {
  active = evaluate(active, Boolean);

  return (
    <div className={cn('control', { active }, className)} {...props}>
      {children}
    </div>
  );
};

Button.propTypes = {
  active: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  children: PropTypes.node,
  className: PropTypes.string
};

export default Button;
